export const OPERATION_MODE = 'OPERATION_MODE';